const temporaryFeatures = {
  // [featureKey]: '[set date YYYY-MM-DD]',
};

export default temporaryFeatures;



/** WEBPACK FOOTER **
 ** ./src/config/temporaryFeatures.js
 **/